import { isMagnoliaAuthoringMode } from '../../helper';

// We use imported types only for the static helpers below
export interface FetchParameters {
  apiUrl: string;
  apiKey: string;
  teaserParams: TeaserParams;
  excludePageIds: string[];
  bearerToken?: string;
}

export interface TeaserParams {
  tagRelation: 'OR' | 'AND';
  limit: number;
  offset: number;
  parentNodeId: string;
  tags?: string[];
}

export function getUrlWithParams(apiUrl: string, teaserParams: TeaserParams, excludePageIds: string[]) {
  const url = new URL(apiUrl);

  // Get search parameters using URLSearchParams
  // language is included on the api url
  const urlSearchParams = new URLSearchParams(url.search);

  Object.entries(teaserParams)
    .filter(([value]) => value !== '')
    .forEach(([key, value]) => {
      // cannot add a comma separated list of tags to the tags query param
      // but api requires it to be in this format tags=tag1&tags=tag2
      if (key === 'tags') {
        value.forEach((tag) => {
          urlSearchParams.append('tags', tag);
        });
      } else {
        urlSearchParams.append(key, value.toString());
      }
    });

  // pass excludePageIds as a parameter to the api
  urlSearchParams.append('excludeNodeIds', excludePageIds.join(','));

  urlSearchParams.append('instance', isMagnoliaAuthoringMode() ? 'author' : 'public');

  url.search = urlSearchParams.toString();

  return url.toString();
}

export async function getTeasers({ apiUrl, apiKey, teaserParams, excludePageIds, bearerToken }: FetchParameters) {
  const url = getUrlWithParams(apiUrl, teaserParams, excludePageIds);
  let data;
  try {
    const response = await fetch(url, {
      headers: {
        'x-api-key': apiKey,
        ...(bearerToken && { Authorization: `Bearer ${bearerToken}` }),
      },
    });
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    data = await response.json();
  } catch (error) {
    console.log(error);
  }

  return data;
}
